import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { injectBrnDialogContext } from '@spartan-ng/brain/dialog';

export interface PolicyIframeDialogContext {
  url: string;
}

@Component({
  selector: 'app-policy-iframe-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (safeUrl(); as url) {
      <iframe
        [src]="url"
        class="w-full h-[80vh] min-h-[400px] border-0 rounded"
        title="Policy document"
      ></iframe>
    }
  `,
})
export class PolicyIframeDialogComponent {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly context = injectBrnDialogContext<PolicyIframeDialogContext>();

  protected readonly safeUrl = computed(() => {
    const url = this.context?.url;
    return url ? this.sanitizer.bypassSecurityTrustResourceUrl(url) : null;
  });
}
